import { TemplateRef } from "@angular/core";
import { Observable } from "rxjs";

export interface IconAction<T> {
  type: 'icon';
  icon: string;
  callback: (element: T) => void;
}

export interface ButtonAction<T> {
  type: 'button';
  label: string;
  style: 'primary' | 'secondary';
  callback: (element: T) => void;
}

export type ActionConfig<T> = IconAction<T> | ButtonAction<T>;

export enum ColumnTypeEnum {
  Text = 'text',
  Chip = 'chip',
  Date = 'date',
  Icon = 'icon',
  Template = 'template',
}

export enum ColorTypeEnum {
  Primary = 'primary',
  Yellow = 'yellow',
  Red = 'red',
  Green = 'green',
}

export interface BaseColumnConfig {
  columnDef: string;
  header: string;
  headerTemplate?: TemplateRef<any>;
  headerClass?: string | string[] | Set<string> | { [klass: string]: any };
  sortable?: boolean;
  type: ColumnTypeEnum;
  hidden?: boolean;
  order?: number;
  cellClass?: string | string[] | Set<string> | { [klass: string]: any };
  cellHidden?: (element: any) => boolean;
  cellOutput?: (value: any) => void;
  sticky?: 'start' | 'end';
}

export interface TextColumnConfig extends BaseColumnConfig {
  type: ColumnTypeEnum.Text;
  cell?: (element: any) => string;
  cell$?: (element: any) => Observable<string> | Promise<string>;
  tooltip?: (element: any) => string;
  tooltip$?: (element: any) => Observable<string> | Promise<string>;
}

export interface ChipColumnConfig extends BaseColumnConfig {
  type: ColumnTypeEnum.Chip;
  cell?: (element: any) => string;
  cell$?: (element: any) => Observable<string> | Promise<string>;
  tooltip?: (element: any) => string;
  tooltip$?: (element: any) => Observable<string> | Promise<string>;
  chipColor?: (element: any) => ColorTypeEnum;
  chipColor$?: (element: any) => Observable<ColorTypeEnum> | Promise<ColorTypeEnum>;
}

export interface DateColumnConfig extends BaseColumnConfig {
  type: ColumnTypeEnum.Date;
  cell?: (element: any) => Date | string;
  cell$?: (element: any) => Observable<Date | string> | Promise<Date | string>;
  tooltip?: (element: any) => string;
  tooltip$?: (element: any) => Observable<string> | Promise<string>;
  format?: string;
}

export interface IconColumnConfig extends BaseColumnConfig {
  type: ColumnTypeEnum.Icon;
  cell?: (element: any) => string;
  cell$?: (element: any) => Observable<string> | Promise<string>;
  color?: (element: any) => ColorTypeEnum;
  color$?: (element: any) => Observable<ColorTypeEnum> | Promise<ColorTypeEnum>;
  tooltip?: (element: any) => string;
  tooltip$?: (element: any) => Observable<string> | Promise<string>;
}

export interface TemplateColumnConfig extends BaseColumnConfig {
  type: ColumnTypeEnum.Template;
  template: TemplateRef<any>;
}

export type ColumnConfig = TextColumnConfig | ChipColumnConfig | DateColumnConfig | IconColumnConfig | TemplateColumnConfig;
export interface PaginationConfig {
  pageSizeOptions?: number[];
  pageSize?: number;
  length?: number;
  hasMore?: boolean;
}
